import { Button, InputAdornment } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import * as Yup from 'yup';
import { useCreateListDataMutation } from '../../api/apiSlice';
import FormikButton from '../../components/formik/FormikButton';
import FormikInput from '../../components/formik/FormikInput';
import Form from '../../components/utilities/Form';
import errorSnackbar from '../../utils/errorSnackbar';

const validate = Yup.object().shape({
    phone: Yup.string().required().min(9).max(10).label('Phone'),
});

export default function RequestCode({
    setPhoneNumber,
    setCodeSent,
    phoneNumber,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [requestResetCode, { isLoading }] = useCreateListDataMutation();

    return (
        <Form
            validationSchema={validate}
            onSubmit={async (vals) => {
                setPhoneNumber('0' + vals.phone);
                const { error, data } = await requestResetCode({
                    list: '/reset/request',
                    body: { phone: '0' + vals.phone },
                });

                errorSnackbar(error, enqueueSnackbar);

                if (data) {
                    enqueueSnackbar('Code requested successfully');
                }
            }}
            initialValues={{ phone: '' }}
        >
            <FormikInput
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">+254</InputAdornment>
                    ),
                }}
                name="phone"
                placeholder="7XXXXXXXX"
            />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <FormikButton loading={isLoading} variant="contained">
                    Send Reset Code
                </FormikButton>
                <Button
                    variant="outlined"
                    disabled={phoneNumber.length < 10}
                    onClick={() => setCodeSent(true)}
                >
                    Enter Code
                </Button>
            </div>
            <br />
        </Form>
    );
}
